module.exports = __webpack_public_path__ + "img/IMG_9181-224_L.f956c46b.webp";